<!-- BEGIN login -->
<div class="login">
    <!-- BEGIN login-content -->
    <div class="login-content">
        <div class="text-center">
            <div class="login-logo account-small-logo"></div>
        </div>
        <br/>
        <br/>
        <br/>
        <br/>
        <form>
            <div class="text text-opacity-50 text-center mb-4">
                Welcome to {{app.applicationName}}. 
            </div>
            <div *ngIf="azureAuthService.account">
                <button [routerLink]="'home'" class="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3">Welcome back {{this.azureAuthService.account.name}}</button>
                <button (click)="logout()" class="btn btn-outline-danger btn-lg d-block w-100 fw-500 mb-3">Log Out</button>
                <div class="text text-opacity-50 text-center mb-4">
                    Login as someone else?
                </div>
            </div>
            <hr>
            <button type="submit" (click)="loginAzure()" class="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3">Login with Azure</button>
        </form>
    </div>
    <!-- END login-content -->
</div>
<!-- END login -->
